import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { getUserFailure, getUserSuccess } from "../slices/features/user";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchUserSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchUser,
      baseUrl,
      id
    );

    yield put(getUserSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(getUserFailure({ statusCode, statusText }));
  }
}

export function* watchfetchUser() {
  yield takeLatest(RequestTypes.GET_USER_REQUEST, fetchUserSaga);
}
